<template>
  <w-sliding-popup ref="alertPopup" :title="title" width="900px" @close="onClosePopup">
    <div slot="content">
      <el-row type="flex" justify="space-between" class="title-bar">
        <div>
          <span class="title-h4 mr-r4">경보 목록</span>
          <el-button class="mr-l4" size="mini" type="primary" :disabled="!ableCheckList" @click="updateAlertInfo">확인</el-button>
          <!-- <el-button size="mini" @click="deleteWarningInfo">삭제</el-button> -->
        </div>
        <div>
          <el-button size="small" type="plain" @click="alertShowSearchTool = !alertShowSearchTool"><i class="fas fa-search" /></el-button>
        </div>
      </el-row>
      <el-table-wrapper ref="alertTable" class="mr-b20" v-loading="isLoading" :data="alertData" :columns="columns" :column-default="columnDefault"
      :pagination="false" :show-custom-header="true" :show-search-tool="alertShowSearchTool" @selection-change="alertSelectionChange">
      <template slot-scope="scope" slot="status-slot">
        <span v-if="scope.row['isChecked'] == 'Y'" :class="getStatusClass(scope.row['isChecked'])">확인</span>
        <span v-else :class="getStatusClass(scope.row['isChecked'])">미확인</span>
      </template>
      </el-table-wrapper>
      <el-row type="flex" justify="space-between" class="title-bar">
        <div>
          <div class="title-h4 mr-r4">확인된 경보</div>
        </div>
        <div>
          <el-button size="small" type="plain" @click="checkShowSearchTool = !checkShowSearchTool"><i class="fas fa-search" /></el-button>
        </div>
      </el-row>
      <el-table-wrapper ref="checkAlertTable" v-loading="isLoading" :data="checkedAlertData" :columns="checkedColumns" :column-default="columnDefault"
      :pagination="false" :show-custom-header="true" :show-search-tool="checkShowSearchTool">
      <template slot-scope="scope" slot="status-slot">
        <span v-if="scope.row['isChecked'] == 'Y'" :class="getStatusClass(scope.row['isChecked'])">확인</span>
        <span v-else :class="getStatusClass(scope.row['isChecked'])">미확인</span>
      </template>
      </el-table-wrapper>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import { isEmpty } from '@/utils/basic';
import { getDateToString } from '@/utils/date';
import { convertThousandSeparatorFormat } from '@/utils/number';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import ApmCountAPI from '@/api/performance/apm/count-info';

export default {
  name: 'WAlertDetailPopup',
  data() {
    return {
      columnDefault,
      columns: [
        {
          type: 'selection',
          width: '55px',
        },
        {
          prop: 'isChecked',
          label: '확인',
          width: 85,
          sortable: true,
          scopedSlot: 'status-slot',
        },
        {
          prop: 'warningCode',
          label: '경보 코드',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'warningDesc',
          label: '경보 설명',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'occuredCount',
          label: '미확인 (건)',
          width: 150,
          sortable: true,
          formatter: this.convertThousandSeparatorFormat,
        },
        {
          prop: 'checkStarttime',
          label: '발생 시각',
          width: 150,
          sortable: true,
          searchable: true,
          searchType: 'date',
          formatter: this.formatDatetime,
        },
      ],
      checkedColumns: [
        {
          prop: 'isChecked',
          label: '확인',
          width: 85,
          sortable: true,
          scopedSlot: 'status-slot',
        },
        {
          prop: 'warningCode',
          label: '경보 코드',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'warningDesc',
          label: '경보 설명',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'checkFinishtime',
          label: '확인 시각',
          width: 150,
          sortable: true,
          searchable: true,
          searchType: 'date',
          formatter: this.formatDatetime,
        },
      ],
      isLoading: false,
      ableCheckList: false,
      alertData: [],
      checkedAlertData: [],
      alertSelectionList: [],
      alertShowSearchTool: false,
      checkShowSearchTool: false,
      alertParams: null,
    };
  },
  computed: {
    title() {
      const alertParams = this.alertParams;
      const title = '상세정보';
      if (!isEmpty(alertParams)) {
        return `${alertParams.title} ${title}`;
      }
      return title;
    },
  },
  watch: {
    alertParams: {
      handler() {
        if (!isNil(this.alertParams)) {
          this.loadAlertDetailData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * Alert 상세정보 팝업을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open(params) {
      this.alertData = [];
      this.checkedAlertData = [];
      this.$refs.alertPopup.visible = true;
      this.alertParams = params;
    },
    /**
     * Alert 상세 리스트를 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadAlertDetailData() {
      if (isEmpty(this.alertParams)) {
        return;
      }
      if (this.$refs.alertTable) {
        this.loadAlertInfo();
      } else {
        this.$nextTick(() => {
          this.loadAlertInfo();
        });
      }
    },
    loadAlertInfo() {
      if (this.isLoading === false) {
        this.isLoading = true;
      }
      const tableSearchParams = this.$refs.alertTable.getParameter();
      const params = {
        ...this.alertParams,
        start: tableSearchParams.start,
        limit: tableSearchParams.limit,
      };
      ApmCountAPI.getAlertRawList(params).then((response) => {
        if (response.data.success) {
          this.alertData = response.data.data.nonCheckInfo;
          this.checkedAlertData = response.data.data.checkedList;
          // this.tableTotal = response.data.total;
        } else {
          this.alertData = [];
          this.checkedAlertData = [];
          // this.tableTotal = 0;
        }
        this.isLoading = false;
      });
    },
    /**
     * 슬라이딩 팝업을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      this.alertParams = null;
      this.alertShowSearchTool = false;
      this.checkShowSearchTool = false;
      this.$refs.alertPopup.visible = false;
      this.$refs.alertTable.clearFilter();
      this.$refs.checkAlertTable.clearFilter();
    },
    alertSelectionChange(row) {
      let checkAlertFlag = false;
      this.alertSelectionList = row;
      row.forEach((item) => {
        if (item.isChecked === 'Y') {
          checkAlertFlag = true;
        }
      });
      if (checkAlertFlag) {
        this.ableCheckList = false;
      } else {
        this.ableCheckList = true;
      }
    },
    /**
     * 발생 일시를 string type으로 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatDatetime(row, column, value) {
      return getDateToString(value, 'YYYY-MM-DD HH:mm:ss');
    },
    convertCheckDatetime(row, column, value) {
      return !isNil(value) ? getDateToString(value, 'YYYY-MM-DD HH:mm:ss') : EMPTY_TEXT;
    },
    updateAlertInfo() {
      const params = cloneDeep(this.alertSelectionList);
      if (!isNil(params)) {
        params.forEach((item) => {
          item.isChecked = 'Y';
          delete item.warningDesc;
        });
      }
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.CHECK)).then(() => {
        ApmCountAPI.updateAlertInfo(params).then((response) => {
          this.loadAlertInfo();
          this.$emit('reload');
          this.$message(msgUtil.getResultMsgData(msgUtil.action.CHECK, '경보', response.data.success));
        });
      });
    },
    // deleteWarningInfo() {
    //   const params = this.alertSelectionList;
    //   ApmCountAPI.deleteAlertInfo(params).then((response) => {
    //     if (response.data.success) {
    //       this.loadAlertDetailData();
    //       this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '경보', response.data.success));
    //     }
    //   });
    // },
    getStatusClass(value) {
      if (value === 'N') {
        return 'state-abnormal';
      } else if (value === 'Y') {
        return 'state-normal';
      }
      return '';
    },
    convertThousandSeparatorFormat(row, column, value) {
      let convertValue = EMPTY_TEXT;
      if (!isNil(value) && value !== '') {
        convertValue = Number(value);
        return convertThousandSeparatorFormat(convertValue);
      }
      return convertValue;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/apm/components/popup/AlertDetailPopup.vue